/**
 * FadeModelCard — custom element for the "Fade Model Card" section.
 *
 * Responsibilities:
 *  1. Fade-in with stagger — each .fmc__fade element observed individually.
 *     Toggles .is-visible on enter/exit so animation repeats on every scroll.
 */

if (!customElements.get('fade-model-card')) {
  class FadeModelCard extends HTMLElement {
    connectedCallback() {
      requestAnimationFrame(() => this._initFade());
    }

    _initFade() {
      if (this.dataset.fade !== 'true') return;

      const els = [...this.querySelectorAll('.fmc__fade')];
      if (!els.length) return;

      // Stagger delays in DOM order (heading → model card → info panel)
      els.forEach((el, i) => {
        el.style.transitionDelay = (i * 130) + 'ms';
      });

      const observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            // Toggle each time — resets when leaving, re-animates on re-entry
            entry.target.classList.toggle('is-visible', entry.isIntersecting);
          });
        },
        { threshold: 0.12, rootMargin: '0px 0px -40px 0px' }
      );

      els.forEach((el) => observer.observe(el));
    }
  }

  customElements.define('fade-model-card', FadeModelCard);
}
